import React from "react";

function downloadIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.625 16.013C11.5083 15.971 11.4 15.9 11.3 15.8L7.7 12.2C7.5 12 7.404 11.7667 7.412 11.5C7.42 11.2333 7.516 11 7.7 10.8C7.9 10.6 8.13767 10.496 8.413 10.488C8.68833 10.48 8.92567 10.5757 9.125 10.775L11 12.65V5.5C11 5.21667 11.096 4.97934 11.288 4.788C11.48 4.59667 11.7173 4.50067 12 4.5C12.2827 4.49934 12.5203 4.59534 12.713 4.788C12.9057 4.98067 13.0013 5.218 13 5.5V12.65L14.875 10.775C15.075 10.575 15.3127 10.479 15.588 10.487C15.8633 10.495 16.1007 10.5993 16.3 10.8C16.4833 11 16.5793 11.2333 16.588 11.5C16.5967 11.7667 16.5007 12 16.3 12.2L12.7 15.8C12.6 15.9 12.4917 15.971 12.375 16.013C12.2583 16.055 12.1333 16.0757 12 16.075C11.8667 16.0743 11.7417 16.0537 11.625 16.013ZM6 20.5C5.45 20.5 4.97933 20.3043 4.588 19.913C4.19667 19.5217 4.00067 19.0507 4 18.5V16.5C4 16.2167 4.096 15.9793 4.288 15.788C4.48 15.5967 4.71733 15.5007 5 15.5C5.28267 15.4993 5.52033 15.5953 5.713 15.788C5.90567 15.9807 6.00133 16.218 6 16.5V18.5H18V16.5C18 16.2167 18.096 15.9793 18.288 15.788C18.48 15.5967 18.7173 15.5007 19 15.5C19.2827 15.4993 19.5203 15.5953 19.713 15.788C19.9057 15.9807 20.0013 16.218 20 16.5V18.5C20 19.05 19.8043 19.521 19.413 19.913C19.0217 20.305 18.5507 20.5007 18 20.5H6Z"
        fill="#424242"
      />
    </svg>
  );
}

export default downloadIcon;
